export default class Connector {
  constructor(bidOptionView, bidSectionView) {
    this.bidOptionView = bidOptionView;

    bidOptionView.on('change:BidOption', (bidOption) => {
      bidSectionView.onBidOptionChanged(bidOption);
    });
  }

  stopListening() {
    this.bidOptionView.off('change:BidOption');
  }
}
